import * as React from "react";
import * as ReactDOM from "react-dom";

import { CostOfCareCalculatorProvider } from "./context/CostOfCareCalculatorState";
import { CostOfCareCalculatorContext } from "./context/CostOfCareCalculatorState";
import { InputComponent } from "./InputComponent";
import { CountryChartComponent } from "./CountryChartComponent";
import { ResultsComponent } from "./ResultsComponent";


const CostOfCareCalculatorApp = (props) => {
    const {
        state,
        dispatch,
    } = React.useContext(CostOfCareCalculatorContext)

    const { data } = props

    React.useEffect(() => {
        //console.log(data)

        FormatChartData(data.ChildCareCostModel)
    }, [])

    const FormatChartData = (costData) => {

        //Format the price spread data
        let feeSpread = costData.averageDailyFeeSpread
        let maxIndex = Object.entries(feeSpread).length

        let minValue = parseFloat(Object.entries(feeSpread)[0][0])
        let maxValue = parseFloat(Object.entries(feeSpread)[maxIndex - 1][0])
        //console.log(minValue, maxValue)

        let boundGroup = []
        let bound = minValue + 10

        // Start from min value and add incrememnts to create a bound object that will later hold the accumulated values of relevant prices within that bound
        do {
            let boundObject = {}
            boundObject[bound] = 0

            boundGroup.push(boundObject)
            bound = bound + 10

        } while (bound < (maxValue + 10));
        //console.log(boundGroup)

        let averageIndex = null
        // Loop through all prices in the spread and add them to the relevant bound group
        Object.entries(feeSpread).forEach(([key, value]) => {

            for (let i = 0; i < boundGroup.length; i++) {
                let bgKey = parseFloat(Object.keys(boundGroup[i])[0])
                if (averageIndex == null && (bgKey > costData.amount)) {
                    averageIndex = i
                }
                // Check if the key of the price spread is below the bound group amount, add it to the boundgroup value
                if (parseFloat(key) < bgKey) {
                    boundGroup[i][bgKey] += value
                    break
                } 
            }
        });

        //console.log(boundGroup, averageIndex)

        let chartLabels = []
        let chartValues = []
        let chartColors = []
        // Loop through bound groups to create chart data arrays
        boundGroup.forEach((object, index) => {
            let label = Object.keys(object)[0]
            let value = Object.values(object)[0]

            // Dont include outlier data ie values below 20??
            if (true) {
                chartLabels.push(Object.keys(object)[0])
                chartValues.push(Object.values(object)[0])
                index == averageIndex ? chartColors.push('rgb(233, 24, 124)') : chartColors.push('rgb(35, 22, 115)')
			}
        })

        maxValue = parseInt(chartLabels[chartLabels.length - 1])

        let nationalAveragePosition = (averageIndex / boundGroup.length) * 100

        let payload = {
            nationalAverageAmount: costData.amount,
            nationalChartData: {
                chartLabels: chartLabels,
                chartValues: chartValues,
                chartColors: chartColors,
                averageItemPosition: nationalAveragePosition.toFixed(0)
            },
            nationalMin: minValue,
            nationalMax: maxValue,
        }
        dispatch({ type: 'SET_MODEL', payload: payload })
    }

    return (
        <React.Fragment>

            <div className="sm:rounded-40px bg-white mb-10 py-7 sm:py-14 px-6 lg:px-24" style={{ boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)' }}>
                <div className="flex flex-row items-center gap-2 mb-4">
                    <h1 className="mb-0" id="coc-title">
                        Cost of child care
			        </h1>
                    {/*<img className="cursor-pointer" x-on:click="$dispatch('openstdmodal', {contentId: '#coc-about'})" src="/img/icons/circle-info-icon.svg" alt="Info icon i inside a circle" />*/}
                </div>

                <div className="mb-4 bg-skin-site-header rounded-lg p-2 lg:p-4 text-base-15">
                    Child care can be expensive depending on where you live. If you’re ineligible for the CCS, you could be paying up to $200 per day for child care.
                    Our Child care cost calculator can help you decide which suburbs are more affordable for your family while knowing your little ones have been left in good hands.
                </div>

                <div className="flex flex-col lg:flex-row mb-4 gap-8 lg:gap-4">
                    {/*Cost Component*/}
                    <InputComponent />

                    {/*Chart Component*/}
                    {!state.hasResults &&
                        <CountryChartComponent />
                    }
                </div>

                {(!state.loading && state.hasResults) &&
                    <ResultsComponent />
                }

                <div id="coc-c4k-recommends"></div>

            </div>

        </React.Fragment>
    );
}

(window as any).RenderCostOfCareCalculatorComponent = function (props) {
    ReactDOM.render(
        <CostOfCareCalculatorProvider>
            <CostOfCareCalculatorApp {...props} />
        </CostOfCareCalculatorProvider>
        , document.getElementById("costOfCareCalculatorComponent"));
}